import React from "react";
import { NavLink } from 'react-router-dom';
import { reactLocalStorage } from "reactjs-localstorage";
import Table from "react-bootstrap/Table";
import { FaPencilAlt, FaTrash, FaList, FaPercentage } from "react-icons/fa";

import TowerAPI from "../../api/TowerAPI";

import ApiUiController from "../../controller/ApiUiController";
import Display from "../../util/Display";
import Util from "../../util/Util";
import withRouter from '../../util/WithRouter';
import Const from "../../util/Constants";
import ProjectConst from "../../util/ProjectConst";

class InnerTowerList extends React.Component {

  static Room = 'room';
  static Refresh = 'refresh';

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).tower_details;
    this.state = { inApiCall: true, towers: [], popup: null, room: null};
    this.RoomTower = {};

    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
  }

  componentDidMount() {
    this.loadProperties();
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.lead && props.lead.id !== this.id) {
      this.loadProperties();
    }
  }

  loadProperties() {
    TowerAPI.getInnerList(this.props.type,this.props.id,this.onReceived,this.props.failure,
      this.props.logout);
  }

  onReceived = (res) => {this.setState({ inApiCall: false, towers: res.data });}
  onDelete = (indx) =>{
    Util.confirmAlert("Delete", "Are you sure you want to delete", "Delete", "No", () => {
        this.setState({ ...this.state, inApiCall: true });
        TowerAPI.delete( this.state.towers[indx].id, this.onDeleteSuccess,
          this.props.failure, this.props.logout );
      }
    );
  }

  onDeleteSuccess = () => {
    Util.showNotification("Successful", "Property deleted successfully", "success");
    this.props.reload();
  };

  showList = () =>
    this.state.towers.map((tower, _i) => (
      <tr key={`tower_${_i + 1}`}>
        <td>
        <NavLink to={`/tower/preview/${tower.id}?project=${this.props.project.id}`}>
        {tower.tower_name}
        </NavLink>
        </td>
        <td>{tower.total_floor}</td>
        <td>{Util.serverStringToDisplayDateTime(tower.created_date)}</td>
        <td>{Display.ModelLabelValue("user", tower.created_by)}</td>
        <td>
          <NavLink to={`/tower/preview/${tower.id}?project=${this.props.project.id}`}>
            <span className="buttons primary"><FaList /> Manage Inventory</span>
          </NavLink>
          <NavLink to={`/floor-rise/preview/${tower.id}?project=${this.props.project.id}`}>
            <span className="buttons success"><FaPercentage /> Floor Rise</span>
          </NavLink>
            { this.Update ?
              <span onClick={evnt => this.props.edit(tower, ProjectConst.Tower)} className="buttons update">
                  <FaPencilAlt /> Edit
              </span>
              : null
            }
            { this.Delete ?
              <span onClick={() => this.onDelete(_i)} className="buttons delete"><FaTrash /> Delete</span>
              : null
            }
        </td>
      </tr>
    ));

    showPopUp = (model, field, indx) => {
        let tmp = {...this.state};
        tmp[field] = model;
        tmp.popup = field;
        this.RoomTower = this.state.towers[indx];
        this.setState({ ...tmp});
    }

    hidePopUp = () => this.setState({ ...this.state, popup: InnerTowerList.Refresh});
    
  render() {
    let uiCalls = this.showList();
    if (this.state.towers.length === 0)
      uiCalls = (
        <tr>
          <td colSpan="9">No Records Found</td>
        </tr>
      );
    return (
      <div className="row">
        <div className="col-md-12">
          <h2>Towers</h2>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Tower Name</th>
                  <th>Total Floors</th>
                  <th>Created Date</th>
                  <th>Created By</th>
                  <th className="actionth">Action</th>
                </tr>
              </thead>
              <tbody>{uiCalls}</tbody>
            </Table>
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default withRouter(InnerTowerList);
